import { Button } from "primereact/button";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import UserHeader from "./UserHeader";
import axios from "axios";
import { useEffect, useState } from "react";
import { getBalance } from "./QueryAccount";

function Account() {
    const navigate = useNavigate();
    const [accountBalanceE6, setAccountBalanceE6] = useState(null);

    useEffect(
        () => {
            getBalance().then(
                (response) => setAccountBalanceE6(response.data.balance_e6)
            ).catch(
                (error) => navigate('/')
            )
        },
        [],
    )

    return (
        <div style={{ marginTop: '4em' }}>
            <Header />
            <div
                className="standard-box3"
                style={{ width: '90%', marginTop: '2em' }}
            >
                <UserHeader user_id={localStorage.getItem('user_id')} />
                <div style={{ marginTop: '1em' }}>
                    <Button
                        severity='danger'
                        label='Logout'
                        onClick={
                            () => {
                                localStorage.removeItem('token');
                                navigate('/');
                            }
                        }
                        size='small'
                    />
                </div>
            </div>
            <div
                className="standard-box3"
                style={{ width: '90%' }}
            >
                <h3>
                    Balance
                </h3>
                {(accountBalanceE6 / 100000).toFixed(2)} EUR
            </div>
            <div
                className="standard-box3"
                style={{ width: '90%' }}
            >
                <h3>
                    Deposit Funds
                </h3>
                <Button
                    label='Activate Voucher'
                    severity='success'
                    size='small'
                    onClick={() => navigate('/voucher/activation/')}
                />
            </div>
        </div>
    );
}

export default Account;